import { useUserStore } from "@/stores/userStore";
import axios from "axios";

/**
 * Axios instance for API calls
 * Configured with base URL and default settings
 */
const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || "http://localhost:3600/api",
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

/**
 * Request interceptor to add auth token to requests
 */
api.interceptors.request.use(
  (config) => {
    // Get token from localStorage (Zustand persist storage)
    const userStorage = localStorage.getItem("user-storage");
    if (userStorage) {
      try {
        const parsed = JSON.parse(userStorage);
        const token = parsed.state?.token;
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      } catch (error) {
        console.error("Error parsing user storage:", error);
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

/**
 * Response interceptor to handle common errors
 */
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Unauthorized - clear user data and redirect to login
      const requestUrl = typeof error.config?.url === "string" ? error.config.url : "";
      const isLogoutRequest = requestUrl.includes("/logout");
      const isOnLoginPage = window.location.pathname === "/login";
      const logout = useUserStore.getState().logout;
      logout();
      if (!isLogoutRequest && !isOnLoginPage) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  },
);

export default api;
